export default {
      id: "icon-spreadsheet-usage",
      viewBox: "0 0 26 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-spreadsheet",
      toString: function () {
        return this.url;
      }
    }